import moment from 'moment'

export const invoiceStates = [
    {
      "code": 1,
      "name": "待开票"
    },
    {
      "code": 2,
      "name": "开票中"
    },
    {
      "code": 3,
      "name": "已开票"
    },
    {
      "code": 4,
      "name": "已拒绝"
    },
    {
      "code": 5,
      "name": "已取消"
    }
  ]

export const searchItems = [
  {
    label: '发票状态',
    type: 'select',
    decorator: ['states'],
    placeholder: '请选择发票状态(不选表示全部)',
    mode: 'multiple',
    option: { data: invoiceStates, keyName: 'code', valName: 'name' }
  },
  // 申请时间
  {
    label: '申请时间',
    type: 'timeRange',
    decorator: [
      'dateTimeRange',
      { initialValue: [moment().subtract(3, 'months').startOf('day'), moment().endOf('day')] }
    ],
    placeholder: ['申请时间 (起始)', '申请时间 (终止)'],
    disabledDate: c => c && c > moment().endOf('day'),
    ranges: {
      今日: [moment().startOf('day'), moment().endOf('day')],
      近一周: [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')],
      近两周: [moment().subtract(15, 'days').startOf('day'), moment().endOf('day')],
      近一月: [moment().subtract(30, 'days').startOf('day'), moment().endOf('day')]
    }
  }
]
